// extracted by mini-css-extract-plugin
export default {"modal":"ModalPopup_modal__lpgT3","modal-visible":"ModalPopup_modal-visible__v97p+","overlay":"ModalPopup_overlay__3RTeM","overlay-visible":"ModalPopup_overlay-visible__9KIGr"};